import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { validators } from '../../utils/validators';

const AdminLogin = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        if (errors[e.target.name]) {
            setErrors({ ...errors, [e.target.name]: '' });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        const validation = validators.validateForm(formData, {
            email: [
                { type: 'required', message: 'Admin email is required' },
                { type: 'email', message: 'Invalid email address' }
            ],
            password: [
                { type: 'required', message: 'Password is required' }
            ]
        });

        if (!validation.isValid) {
            setErrors(validation.errors);
            return;
        }

        setLoading(true);
        const result = await login(formData.email, formData.password);

        if (result.success) {
            if (result.data.role === 'admin') {
                navigate('/admin/dashboard');
            } else if (result.data.role === 'franchise-admin') {
                navigate('/franchise/dashboard');
            } else {
                setMessage('Access Denied. This portal is for administrators only.');
                // Optional: Logout if they logged in with a non-admin account on the admin page
            }
        } else {
            setMessage(result.error || 'Invalid admin credentials.');
        }

        setLoading(false);
    };

    return (
        <div className="auth-page admin-auth">
            <Link to="/" className="back-to-website-btn">
                <span>←</span> Back to Website
            </Link>
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header" style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <img 
                            src="/Yathartha-Logo.png" 
                            alt="Yathartha" 
                            style={{ height: '50px', marginBottom: '20px' }} 
                        />
                        <div className="admin-badge" style={{ 
                            background: '#1e3a8a', 
                            color: 'white', 
                            padding: '4px 12px', 
                            borderRadius: '4px', 
                            fontSize: '12px', 
                            display: 'inline-block',
                            marginBottom: '10px',
                            fontWeight: 'bold'
                        }}>ADMIN PORTAL</div>
                        <h1>Admin Sign In</h1>
                        <p className="auth-subtitle">Access the management dashboard</p>
                    </div>

                    {message && <div className="error-message">{message}</div>}

                    <form onSubmit={handleSubmit} className="auth-form">
                        <Input
                            label="Administrator Email"
                            type="email"
                            name="email"
                            placeholder="Enter Email"
                            value={formData.email}
                            onChange={handleChange}
                            error={errors.email}
                            required
                        />

                        <div className="input-group">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={handleChange}
                                className={errors.password ? 'error' : ''}
                                required
                            />
                            {errors.password && <span className="error-text" style={{ fontSize: '12px', color: '#ef4444' }}>{errors.password}</span>}
                        </div>

                        <Button
                            type="submit"
                            variant="primary"
                            disabled={loading}
                            className="auth-submit"
                            style={{ backgroundColor: '#1e3a8a' }}
                        >
                            {loading ? 'Verifying Admin...' : 'Login to Dashboard'}
                        </Button>
                    </form>

                    <div className="auth-footer">
                        <Link to="/" style={{ color: '#64748b' }}>Return to Public Website</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
